import React, { useEffect } from "react";
import { Activity, Sandbox, Deploy, Analysis, Settings } from "../component";
import { GetBotUsedDoc, GetCrawlLink } from "../../../apis";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";

const SelectedBot = ({ dispatch, state, handelTrain, trainLoad }) => {
  const activeTab = state.activeBotMenus || "";

  const bot_id = state?.selectedBot?.botId || "";
  const botData = state.botResources[bot_id] || {};

  useEffect(() => {
    const fetchUsedDocs = async () => {
      try {
        if (!bot_id) return;

        const res = await GetBotUsedDoc(bot_id);

        if (res.error) {
          // dispatch({ type: "setUsedDocs", payload: [] });

          dispatch({
            type: "UPDATE_BOT_RESOURCE",
            payload: {
              botId: bot_id,
              data: {
                usedDocs: [],
              },
            },
          });
        } else {
          dispatch({
            type: "UPDATE_BOT_RESOURCE",
            payload: {
              botId: bot_id,
              data: {
                usedDocs: res.data,
              },
            },
          });
          // dispatch({ type: "setUsedDocs", payload: res.data });
        }
      } catch (err) {
        console.error("Error fetching used docs:", err);
        // dispatch({ type: "setUsedDocs", payload: [] });

        dispatch({
          type: "UPDATE_BOT_RESOURCE",
          payload: {
            botId: bot_id,
            data: {
              usedDocs: [],
            },
          },
        });
      }
    };

    if (bot_id) {
      fetchUsedDocs();
    }
  }, [bot_id, dispatch]);

  useEffect(() => {
    const fn = async () => {
      const crawlCatch = state?.selectedBot?.catch?.crawlurls || [];

      if (!bot_id || crawlCatch.length === 0) return;

      const botData = state?.botResources?.[bot_id] || {};
      const existingUrls = botData?.urls || [];

      for (let i = 0; i < crawlCatch.length; i++) {
        const url = crawlCatch[i];

        // Skip if already added
        if (existingUrls.some((ele) => ele.domain === url)) {
          continue;
        }

        const res = await GetCrawlLink(url);
        if (res.error || !(res.data?.length > 0)) {
          continue;
        }

        const newUrlObj = {
          type: "crawl",
          domain: url,
          uuid: uuidv4(),
          data: res.data,
        };

        dispatch({
          type: "UPDATE_BOT_RESOURCE",
          payload: {
            botId: bot_id,
            data: {
              urls: [...existingUrls, newUrlObj],
            },
          },
        });
      }
    };

    fn(); // ✅ Call it
  }, [bot_id, dispatch]);

  const user = useSelector((sta) => sta.user.user);
  const userId = user?.userId;

  return (
    <div className="flex  flex-1 flex-col text-base">
      {activeTab === "sandbox" && (
        <Sandbox
          dispatch={dispatch}
          state={state}
          handelTrain={handelTrain}
          trainLoad={trainLoad}
        />
      )}

      {activeTab === "deploy" && <Deploy selectedBot={state?.selectedBot} />}
      {activeTab === "activity" && (
        <Activity userId={userId} botId={state?.selectedBot?.botId} />
      )}
      {activeTab === "analytics" && (
        <Analysis userId={userId} botId={state?.selectedBot?.botId} />
      )}
      {activeTab === "settings" && (
        <Settings
          userId={userId}
          botId={state?.selectedBot?.botId}
          state={state}
          dispatch={dispatch}
        />
      )}
    </div>
  );
};

export default SelectedBot;
